export enum ManagerErrors {
  passwordExists,
  emailExists,
  phoneExists,
}

export enum UserErrors {
  existed,
  resendedMailForActivate,
  invalidData,
}
